import { useState } from "react";
import { useDataProvider, useNotify, useRefresh, useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";

import type { CrmDataProvider } from "../providers/types";
import type { Lead } from "../types";
import { formatDuration } from "./leadUtils";

export const ClaimLeadButton = ({
  lead,
  size = "sm",
}: {
  lead: Lead;
  size?: "sm" | "default";
}) => {
  const dataProvider = useDataProvider<CrmDataProvider>();
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();
  const [loading, setLoading] = useState(false);

  if (lead.sales_id != null) return null;

  const claim = async (event: React.MouseEvent) => {
    event.stopPropagation();
    setLoading(true);
    try {
      const result = await dataProvider.claimLead(lead.id);
      notify(
        translate("resources.leads.notification.claimed", {
          duration: formatDuration(result?.seconds),
        }),
        { type: "success" },
      );
      refresh();
    } catch (error) {
      notify(error instanceof Error ? error.message : "Fehler", {
        type: "error",
      });
      refresh();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button size={size} onClick={claim} disabled={loading}>
      {translate("resources.leads.action.claim")}
    </Button>
  );
};
